export const primary = "#485666";
export const secondary = "#E8E6DF";
export const white = "rgb(255, 255, 255)";
export const black = "rgb(0, 0, 0)";
export const grey = "rgb(145, 145, 145)";
